import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';

export type DividerProps = {
  className?: string;
  colour?: 'black' | 'gray' | 'green' | 'blue' | 'red' | 'yellow' | 'white';
};

const Divider: FC<DividerProps> = (props) => {
  const { className, colour = 'gray' } = props;

  return (
    <hr
      className={clstx(
        colour === 'black' && 'border-gray-800 dark:border-white',
        colour === 'gray' && 'border-gray-200 dark:border-gray-500',
        colour === 'green' && 'border-green-500',
        colour === 'blue' && 'border-blue-500',
        colour === 'red' && 'border-red-500',
        colour === 'yellow' && 'border-yellow-500',
        colour === 'white' && 'border-white',
        className
      )}
    />
  );
};

export default Divider;
